export default function apiUrl() {
  const api_url = "https://api.prostom.space";
  return api_url;
}
